import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import logo from '../../assets/images/logo.svg';
import { useAuth } from '../../hooks';
import VersionApp from '../version-app';

import { useAuth0 } from '@auth0/auth0-react';

const NavPrimary = () => {
  const { logout } = useAuth0();
  const { logout: contextLogout } = useAuth();

  const handleLogout = () => {
    contextLogout();
    logout({ logoutParams: { returnTo: window.location.origin + '/' } });
  };

  return (
    <>
      <Navbar bg="dark" variant="dark" expand="lg">
        <Container fluid>
          <Navbar.Brand href="/"><img src={logo} alt="Logo"></img></Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav className="me-auto my-2 my-lg-0">
              <Nav.Link href="/agency/list">Agencias</Nav.Link>
              <Nav.Link href="/report/create">Reportes</Nav.Link>
              <Nav.Link href="/user/list">Usuarios</Nav.Link>
            </Nav>
            <Nav className="d-flex">
              <Nav.Link href="/">Sistema CSI</Nav.Link>
            </Nav>
            <Nav className="d-flex">
              <Nav.Link
                as="button"
                type="button"
                className="border-start nav-link"
                onClick={handleLogout}
              >
                <span className="icon-logout me-2"></span>Cerrar Sesión
              </Nav.Link>
              <VersionApp isLogin = {false} />
            </Nav>
            
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  )
};

export default NavPrimary;


// versión sin auth0

// import Container from 'react-bootstrap/Container';
// import Nav from 'react-bootstrap/Nav';
// import Navbar from 'react-bootstrap/Navbar';
// import logo from '../../assets/images/logo.svg';
// import { useAuth } from '../../hooks';
// import VersionApp from '../version-app';

// const NavPrimary = () => {
//   const { logout } = useAuth();

//   const handleLogout = () => {
//     logout();
//   };

//   return (
//     <>
//       <Navbar bg="dark" variant="dark" expand="lg">
//         <Container fluid>
//           <Navbar.Brand href="/"><img src={logo} alt="Logo"></img></Navbar.Brand>
//           <Navbar.Toggle aria-controls="navbarScroll" />
//           <Navbar.Collapse id="navbarScroll">
//             <Nav className="me-auto my-2 my-lg-0">
//               <Nav.Link href="/agency/list">Agencias</Nav.Link>
//               <Nav.Link href="/report/create">Reportes</Nav.Link>
//               <Nav.Link href="/user/list">Usuarios</Nav.Link>
//             </Nav>
//             <Nav className="d-flex">
//               <Nav.Link href="/">Sistema CSI</Nav.Link>
//             </Nav>
//             <Nav onSelect={handleLogout} className="d-flex">
//               <Nav.Link href='/' className="border-start"><span className="icon-logout me-2"></span>Cerrar Sesión</Nav.Link>
//               <VersionApp isLogin = {false} />
//             </Nav>
            
//           </Navbar.Collapse>
//         </Container>
//       </Navbar>
//     </>
//   )
// };

// export default NavPrimary;
